import { useLocation } from "react-router-dom";

import { Container, Step, StepContainer, List } from "./style";

export default function Steps() {
  const { pathname } = useLocation();
  const influRoutes = ["/influ", "/personal_data-influ", "/submit_form-influ"];

  return (
    <Container>
      {influRoutes.includes(pathname) ? (
        <>
          <List>
            <Step
              active={pathname.includes("/personal_data-influ")}
              closed={pathname === "/submit_form-influ"}
            >
              1
            </Step>

            <Step active={pathname.includes("/submit_form-influ")}>2</Step>
          </List>
        </>
      ) : (
        <>
          <StepContainer>
            <Step
              active={pathname.includes("/personal_data")}
              closed={
                pathname === "/experience" ||
                pathname === "/descriptive_questions" ||
                pathname === "/submit_form"
              }
            >
              1
            </Step>
            <Step
              active={pathname.includes("/experience")}
              closed={
                pathname === "/descriptive_questions" ||
                pathname === "/submit_form"
              }
            >
              2
            </Step>
            <Step
              active={pathname.includes("/descriptive_questions")}
              closed={pathname.includes("/submit_form")}
            >
              3
            </Step>
            <Step active={pathname.includes("/submit_form")}>4</Step>
          </StepContainer>
        </>
      )}
    </Container>
  );
}
